module.exports = __webpack_public_path__ + "static/img/6areaA_5.abe9bad.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/6areaA_5.png
// module id = 1040
// module chunks = 1